import { Tab, Tabs } from "@blueprintjs/core";
import React from "react";

import PanelLabelList from "core/components/label/PanelLabelList";
import PanelConfigForm from "./PanelConfigForm";
import PanelBorderForm from "./PanelMetaForm";
import PanelViewList from "./PanelViewList";

/**
 * menu of panel-related config forms
 */

interface IPanelConfigProps {
	instance: string;
	verticalNav?: boolean;
}

export default class PanelConfig extends React.Component<IPanelConfigProps> {

	public render() {

		return (
			<Tabs id="forms" vertical={this.props.verticalNav} renderActiveTabPanelOnly={true}>

				<Tab
					id="panel"
					title="Config"
					panel={
						<PanelConfigForm instance={this.props.instance} />
					}
				/>

				<Tab
					id="general"
					title="General"
					panel={
						<PanelBorderForm instance={this.props.instance} />
					}
				/>

				<Tab
					id="views"
					title="Views"
					panel={
						<PanelViewList instance={this.props.instance} />
					}
				/>

				<Tab
					id="labels"
					title="Labels"
					panel={
						<PanelLabelList instance={this.props.instance} />
					}
				/>

			</Tabs>
		);
	}
}



// WEBPACK FOOTER //
// ./src/core/components/editor/panels/PanelEdit.tsx